import PropTypes from 'prop-types';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { defaultMemoize } from 'reselect';
import I18n from 'I18n';
import { connect } from 'react-redux';
import UIButton from 'UIComponents/button/UIButton';
import { Button } from 'foundations-components/transitional/components/Button';
import UISideNav from 'UIComponents/nav/UISideNav';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import { isApplicationHubless } from '../selectors/AuthSelector';
import { getHasMultiEmailAccess } from '../selectors/EmailsSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASIC = 'basic';
const NOTICATIONS = 'notifications';
const SECURITY = 'security';
const EMAILS = 'emails';
const TFA = 'tfa';
class UserPreferencesSidebar extends Component {
  renderHubless() {
    const {
      activeTab
    } = this.props;
    const search = window.location.search;
    return /*#__PURE__*/_jsxs(UISideNav, {
      value: activeTab,
      children: [/*#__PURE__*/_jsx(Button, {
        value: BASIC,
        use: "unstyled",
        href: BASIC,
        children: I18n.text('userPreferences.basicInfo')
      }), /*#__PURE__*/_jsx(UIButton, {
        value: SECURITY,
        use: "unstyled",
        onClick: () => {
          this.props.history.push({
            pathname: SECURITY,
            search
          });
        },
        children: I18n.text('userPreferences.security')
      })]
    });
  }
  renderWithNotifications() {
    const {
      activeTab
    } = this.props;
    return /*#__PURE__*/_jsxs(UISideNav, {
      value: activeTab,
      children: [/*#__PURE__*/_jsx(UISideNavItem, {
        onClick: () => {
          this.props.history.push(BASIC);
        },
        title: I18n.text('userPreferences.basicInfo'),
        value: BASIC
      }), /*#__PURE__*/_jsx(UISideNavItem, {
        onClick: () => {
          this.props.history.push(SECURITY);
        },
        title: I18n.text('userPreferences.security'),
        value: SECURITY
      })]
    });
  }
  renderDefault() {
    const {
      activeTab
    } = this.props;
    return /*#__PURE__*/_jsxs(UISideNav, {
      value: activeTab,
      children: [/*#__PURE__*/_jsx(UIButton, {
        value: BASIC,
        use: "unstyled",
        onClick: () => {
          this.props.history.push(BASIC);
        },
        children: I18n.text('userPreferences.basicInfo')
      }), /*#__PURE__*/_jsx(UIButton, {
        value: NOTICATIONS,
        use: "unstyled",
        onClick: () => {
          this.props.history.push(NOTICATIONS);
        },
        children: I18n.text('userPreferences.notification')
      }), /*#__PURE__*/_jsx(UIButton, {
        value: SECURITY,
        use: "unstyled",
        onClick: () => {
          this.props.history.push(SECURITY);
        },
        children: I18n.text('userPreferences.security')
      })]
    });
  }
  render() {
    const {
      hasNotificationsAccess,
      isHubless,
      hasMultiEmailAccess
    } = this.props;
    if (!hasMultiEmailAccess) {
      if (isHubless) {
        return this.renderHubless();
      }
      if (hasNotificationsAccess) {
        return this.renderWithNotifications();
      }
      return this.renderDefault();
    }
    const {
      activeTab
    } = this.props;
    return /*#__PURE__*/_jsxs(UISideNav, {
      value: activeTab,
      children: [/*#__PURE__*/_jsx(UISideNavItem, {
        onClick: () => {
          this.props.history.push(BASIC);
        },
        title: I18n.text('userPreferences.basicInfo'),
        value: BASIC
      }), /*#__PURE__*/_jsxs(UISideNavItem, {
        title: I18n.text('userPreferences.security'),
        defaultOpen: true,
        children: [/*#__PURE__*/_jsx(UISideNavItem, {
          onClick: () => {
            this.props.history.push(EMAILS);
          },
          title: I18n.text('emails.title.sidebar'),
          value: EMAILS
        }), /*#__PURE__*/_jsx(UISideNavItem, {
          onClick: () => {
            this.props.history.push(TFA);
          },
          title: I18n.text('tfa.title.sidebar'),
          value: TFA
        })]
      })]
    });
  }
}
UserPreferencesSidebar.propTypes = {
  activeTab: PropTypes.string.isRequired,
  hasMultiEmailAccess: PropTypes.bool,
  hasNotificationsAccess: PropTypes.bool,
  isHubless: PropTypes.bool.isRequired
};
const getActiveTabIdFromPath = defaultMemoize(pathname => {
  const split = pathname.split('/');
  if (split.length > 2 || split[1] === '') {
    return 'default';
  }
  let activeTab = split[1];
  if (activeTab === 'default') {
    activeTab = 'basic';
  }
  return activeTab;
});
const mapStateToProps = (state, {
  location
}) => {
  const hasMultiEmailAccess = getHasMultiEmailAccess(state);
  const isHubless = isApplicationHubless(state);
  const activeTab = getActiveTabIdFromPath(location.pathname);
  const hasNotificationsAccess = !isHubless;
  return {
    activeTab,
    hasNotificationsAccess,
    isHubless,
    hasMultiEmailAccess
  };
};
export default withRouter(connect(mapStateToProps)(UserPreferencesSidebar));